import * as React from 'react';
import { useDebugMode } from '@/app/state/DebugModeContext';

/**
 * Debug Mode Toggle Component
 *
 * Provides a UI toggle for enabling/disabling debug mode.
 * Only visible in development or when debug mode is already enabled.
 */
export const DebugModeToggle: React.FC = () => {
  const { debugMode, toggleDebugMode } = useDebugMode();

  // Only show in development or when debug mode is active
  if (!import.meta.env.DEV && !debugMode) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={toggleDebugMode}
        className={`
          flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium
          transition-all duration-200 shadow-lg
          ${
            debugMode
              ? 'bg-amber-500 dark:bg-amber-600 text-white hover:bg-amber-600 dark:hover:bg-amber-700'
              : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }
        `}
        title={debugMode ? 'Disable debug mode' : 'Enable debug mode'}
      >
        <svg
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
          />
        </svg>
        <span>Debug {debugMode ? 'ON' : 'OFF'}</span>
      </button>
    </div>
  );
};
